var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Modal from '@rad/components/ui/modal';
import ActionButton from '@rad/components/ui/action-button';
import { updateUserRoles } from '../../../common/network/users';
import { useToast } from '../../../contexts/toast';
import RolePicker from './role-picker';
const fullName = (m) => `${m.firstName} ${m.lastName}`.trim() || m.email;
const MemberRolesModal = (props) => {
    const toast = useToast();
    const [selected, setSelected] = useState([]);
    const member = props.member;
    useEffect(() => {
        if (member)
            setSelected(member.roles);
    }, [member]);
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!member)
            return;
        const [success, errors] = yield updateUserRoles(member.id, selected);
        if (!success) {
            // The server refuses self-edits, escalation, and removing the last person who can manage
            // people. Each refusal explains itself, so pass it through rather than inventing a message.
            toast.error(errors.map(e => e.message).join('\n') || 'Their role could not be changed.');
            return;
        }
        props.onSaved();
        props.onClose();
        toast.success(`Updated what ${fullName(member)} can do.`);
    });
    return (_jsxs(Modal, { isOpen: member !== null, title: member ? `What can ${fullName(member)} do?` : 'Roles', onClose: props.onClose, footer: _jsxs(_Fragment, { children: [_jsx("button", { className: "btn btn-outline-secondary me-2", onClick: props.onClose, children: "Cancel" }), _jsx(ActionButton, { className: "btn btn-primary", onClick: handleSave, loadingText: "Saving...", children: "Save" })] }), children: [_jsx("p", { children: "Tick everything this person does for this community. Leave them all unticked if they are just a resident." }), _jsx(RolePicker, { roles: props.roles, value: selected, onChange: setSelected })] }));
};
export default MemberRolesModal;
